export default __webpack_public_path__ + "static/0125-5b3d2f129d3809ace071769b9923a21f.png";